import Image from "next/image";

/**
 * Aditya Labs brand v2 — exact primary symbol component.
 *
 * Renders the screenshot-derived PNG lockup for the primary symbol.
 * The archived SVG remains in the repo only as reference; runtime
 * surfaces use the PNG so the approved visual stays exact.
 */
interface PrimarySymbolProps {
  /** Pixel size of the square symbol. Defaults to 32. */
  size?: number;
  /** Additional class names on the rendered image. */
  className?: string;
  /** Accessible label. Defaults to "Aditya Labs primary symbol". */
  alt?: string;
  /** When true, the image is hidden from assistive tech. */
  decorative?: boolean;
}

export default function PrimarySymbol({
  size = 32,
  className = "",
  alt = "Aditya Labs primary symbol",
  decorative = false,
}: PrimarySymbolProps) {
  return (
    <Image
      src="/brand/exact/aditya-labs-final-symbol-favicon-appicon.png"
      alt={decorative ? "" : alt}
      width={size}
      height={size}
      className={`block ${className}`}
      aria-hidden={decorative ? true : undefined}
    />
  );
}
